<sym-card-dialog [closeMethod]="closeMethod" [title]="'Delete ' + identifier" [delete]="true">
  <div>Are you sure you want to delete  {{identifier}}: <b>{{name}}</b>?</div>
  <mat-divider style="margin: 32px 12px 12px 12px"></mat-divider>
      <div fxLayout="row" fxLayoutAlign="end center">
        
        <button id="btnClass" matTooltip ="Delete {{identifier}}" class="m-12 white-fg" mat-raised-button type="button" (click)="delete()" style="background-color: #9E1414;">Delete 
         {{identifier}}</button>
      </div>
</sym-card-dialog>